module.exports = __webpack_public_path__ + "media/images/svg/clients/10-0f801c4e6d6e12e38fe82439a1df2428.svg";